var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.view,staticClass:"d-flex flex-column h-100",attrs:{"id":"app"}},[_c('Navigation',{attrs:{"display":_vm.displayNav}}),_c('div',{staticClass:"container-fluid flex-grow-1 p-0"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }